import * as React from 'react';
import { st, classes } from './InfoIcon.st.css';
import './InfoIcon.responsive.st.css';
import Tooltip from '../Tooltip';
import { AlertCircleBoldSmall, InfoSmall as InfoCircleSmall, } from '../../icons';
const Icon = React.forwardRef(({ className, icon, size, dataHook, ...props }, ref) => {
    let IconSVG;
    switch (`${size}-${icon}`) {
        case 'small-error':
        case 'medium-error':
            IconSVG = AlertCircleBoldSmall;
            break;
        case 'small-info':
        case 'medium-info':
        default:
            IconSVG = InfoCircleSmall;
    }
    return (React.createElement("button", { ...props, className: st(classes.root, { icon, size }, className), ref: ref, "data-hook": dataHook }, typeof icon === 'string' ? React.createElement(IconSVG, null) : icon));
});
const InfoIcon = ({ dataHook, className, icon = 'info', size = 'medium', disabled = false, tooltipProps = {}, ...props }) => (React.createElement(Tooltip, { ...tooltipProps, dataHook: 'tooltip-' + dataHook },
    React.createElement(Icon, { ...props, className: className, icon: icon, size: size, disabled: disabled, dataHook: dataHook })));
export default InfoIcon;
//# sourceMappingURL=InfoIcon.js.map